import {
  ContentCopy as ContentCopyIcon,
  DeleteOutline as DeleteOutlinedIcon,
  Edit as EditIcon,
  Link as LinkIcon,
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { Menu } from 'src/components/menu';
import { Snackbar } from 'src/components/snackbar';
import { PATHS } from 'src/constants/paths';
import { useGetEnvironment } from 'src/hooks';
import { IStatus } from 'src/interfaces';
import { IPhase } from 'src/interfaces/Phase';
import { lang, useUserRole } from 'src/utils';
import { componentEditFromCardEvent } from 'src/utils/google-tag-manager';

import { ComponentMenuProps } from './ComponentMenu.interface';

export const ComponentMenu = (props: ComponentMenuProps) => {
  const navigate = useNavigate();
  const { data: environment } = useGetEnvironment();
  const { isViewOnly } = useUserRole();

  const onGetLinkClick = async () => {
    try {
      await navigator.clipboard.writeText(
        `${environment?.urls.mtUI}/cc-ui/#/components/details/${props.card.id}`,
      );

      Snackbar.success(`Link to ${props.card.name} ${lang.successfullyCopied}`);
    } catch (error) {
      Snackbar.error(`${lang.failedToCopyComponent}`);
    }
    props.onClose();
  };

  const onDeleteClick = async () => {
    props.onDeleteClick();
    props.onClose();
  };

  const onConvertDraftClick = async () => {
    props.onConvertDraftClick();
    props.onClose();
  };

  const onDuplicateClick = async () => {
    props.onDuplicateClick();
    props.onClose();
  };

  const items = [
    ...(props.card.status !== IStatus.READY
      ? [
          {
            label: lang.edit,
            onClick: () => {
              componentEditFromCardEvent(props.card.id);
              navigate(PATHS.COMPONENT_EDIT(props.card.id));
            },
            leftIcon: <EditIcon />,
            disabled: isViewOnly,
          },
        ]
      : []),
    {
      label: lang.duplicate,
      onClick: onDuplicateClick,
      leftIcon: <ContentCopyIcon />,
      disabled: isViewOnly,
    },
    ...(props.card.status === IStatus.READY &&
    Boolean(props.card.phase === IPhase.UNUSED)
      ? [
          {
            label: lang.convertToDraft,
            onClick: onConvertDraftClick,
            leftIcon: <EditIcon />,
            disabled: isViewOnly,
          },
        ]
      : []),
    // {
    //   label: 'Move to folder',
    //   onClick: () => {},
    //   leftIcon: <FolderIcon />,
    //   disabled: true,
    // },
    {
      label: lang.getLink,
      onClick: onGetLinkClick,
      leftIcon: <LinkIcon />,
    },
    ...(props.card.status !== IStatus.READY
      ? [
          {
            label: lang.deleteText,
            onClick: onDeleteClick,
            leftIcon: <DeleteOutlinedIcon />,
            disabled: isViewOnly,
          },
        ]
      : []),
  ];

  return (
    <>
      <Menu anchorEl={props.anchorEl} items={items} onClose={props.onClose} />
    </>
  );
};
